<template>
  <div>
    <div class=" mainLoader" v-if="loading">
    </div>
    <span class="d-none">{{calculateAverage}}</span>
    <div class="col-md-12" style="margin-top: 45px;" id="ManC"> 
      <div v-for="(question,questionKey) in questions" :key="questionKey" class="skill_questions">
        <h3 class="m-0">{{ lan=='en' ? question.skillquestionEn : question.skillquestionJp}}</h3>

        <div v-if="question.multiselect === true && question.skilldropdown != ''">
          <label class="typo__label">{{$t('r_select')}} {{ lan=='en' ? question.skillquestionEn :
            question.skillquestionJp}}</label>
          <multiselect v-if="question.skillLevels.length != 1"
                       v-model="question.chooseskill"
                       placeholder="Search" label="name" track-by="code"
                       :options="question.skilldropdown" :multiple="true"
                       :taggable="true" :id="questionKey"
                       @tag="addNewSkill"
          >

            <template slot="tag" slot-scope="props">
              <div class="option__desc skillTag">
                <span class="option__title">{{ lan=='en' ? props.option.name : props.option.jp_name }}</span>
                <span class="custom__remove" @click="props.remove(props.option)">
                                    <i style="right: 6px; position: absolute;  cursor:pointer"
                                       @click="clearSkillLevel(''+questionKey+'',question.skillLevels,question.chooseskill)"
                                       class="fa fa-times" aria-hidden="true"></i>
                                </span>
              </div>
            </template>
            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <span class="option__title">{{ lan=='en' ? props.option.name : props.option.jp_name }}</span>
              </div>
            </template>
          </multiselect>
          <multiselect v-if="question.skillLevels.length == 1"
                       v-model="question.chooseskill"
                       placeholder="Search" label="name" track-by="code"
                       :options="question.skilldropdown" :multiple="true"
                       :taggable="true" :id="questionKey"
                       @tag="addNewSkill"
                       @input="SkillUpdateAutomatic(question.chooseskill ,questionKey,question.skillLevels)">

            <template slot="tag" slot-scope="props">
              <div class="option__desc skillTag">
                <span class="option__title">{{ lan=='en' ? props.option.name : props.option.jp_name }}</span>
                <span class="custom__remove" @click="props.remove(props.option)">
                                    <i style="right: 6px; position: absolute; cursor:pointer" class="fa fa-times"
                                       aria-hidden="true"></i>
                                </span>
              </div>
            </template>
            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <span class="option__title">{{ lan=='en' ? props.option.name : props.option.jp_name }}</span>
              </div>
            </template>
          </multiselect>
        </div>
        <div v-if="question.skilldropdown.length == 0">
          <label class="typo__label">{{ lan=='en' ? question.skillquestionDescriotion :
            question.skillquestionJpDescriotion}}</label>
          <div class="regselectboxs  form-group w-100">
            <input style="min-height:50px" :placeholder="$t('sk_custom_placeholder')"
                   type="text"
                   class="form-control"
                   name="lastname"
                   v-model="customManagementSkill[question.id]"
                   @blur="updateId"
            />
          </div>
        </div>
        <div class="chooseskillssection" v-if="question.chooseskill.length > 0 ">
          <label class="typo__label">{{ lan=='en' ? question.skillquestionDescriotion : question.skillquestionJpDescriotion}}
          </label>
          <div class="selectskill">
            <ul>
              <draggable v-model="question.chooseskill"
                        :options="{group:{ name:'people',  pull:'clone', put:false, disabled: true },animation:150}"
                        @remove="updateskill($event,questionKey)">
                <li v-for="(skill,index) in question.chooseskill" :key="index" :id="'li'+skill.code">
                  <input type="checkbox"
                        v-on:click="selectskilllevel(''+skill.id+'',''+skill.name+'',''+skill.code+'', '' + skill.jp_name,''+questionKey+'')"
                        class="toggle" v-model="skill.clicked" :id="'checkbox'+skill.code+questionKey">
                  <label :for="'checkbox'+skill.code+questionKey" :class="{clicked: skill.clicked}">{{ lan=='en' ?
                    skill.name : skill.jp_name}} <i
                      :class="{facheck: skill.clicked}" class="fa "></i></label>
                </li>
              </draggable>
            </ul>
          </div>
         
          <div class="selectexpertlevel" v-if="question.userSkillLevels.length > 0 || question.chooseskill.length > 0 ">
            <div class="level_btns" v-for="(level,index) of question.skillLevels" :key="index">
              <input :id="'question'+questionKey + index" type="radio" name="expertlevel" value="0"
                     v-on:click="updateSkillLevel(index,questionKey,level.id)">
              <label :for="'question'+questionKey + index">{{ lan == 'en' ? level.name : level.jp_name}}</label>
              <div class="resultshow">
                <draggable v-model="question['userSkillLevel' + ((index) +1) ]"
                           :options="{group:'people' ,animation:150, disabled: true}">
                  <ul v-for="(userSkillLevel,uSLKey) in question['userSkillLevel' + (index + 1)]" :key="uSLKey">
                    <li>
                                            <span>{{ lan=='en' ? userSkillLevel.name : userSkillLevel.jp_name}} <i
                                              v-on:click="clearCurrentSkillLevel(''+userSkillLevel.code+'',''+questionKey+'')"
                                              class="fa fa-close"></i>
                                            </span>
                    </li>
                  </ul>
                </draggable>
              </div>
            </div>

          </div>
          <div class="skillUpdate row" v-if="question.definitions.length > 0 ">
            <label class="typo__label">{{$t('definition')}}</label> 
            <div class="col-md-12">
                  <span class="layer">
                    <ul>
                      <li v-for="(definition,index) of question.definitions" :key="index">
                          {{ lan=='en' ? definition.definition : definition.jp_definition}}
                      </li>
                    </ul>

                  </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import {EventBus} from "../../main.js";

  var draggable = require("vuedraggable");
  var Sortable = require("sortablejs");

  export default {
    data() {
      return {
        customManagementSkill: [],
        isActive: true,
        lan: "",
        questions: [],
        finalResult: [],
        collectionList: [],
        levelAppend: [],
        mangQue: [],
        type: "",
        types: [],
        category: "",
        categories: [],
        item: "",
        items: [],
        loading: false,
        loaded: false,

        model: {},

        skillLevelId: [],
        itemId: [],
        skill: "",
        type: "",
        level: "",

        skills: [],
        panelid: 1,

        isTechnicalQuestionsLoaded: false,
        isManagementQuestionsLoaded: false,

        userSkillResponse: {},
        result : ''
      };
    },
    components: {
      draggable
    },
    created() {
      if ("lan" in localStorage) {
        this.lan = localStorage.getItem("lan");
      }
      this.getManagementCollection();
    },
    mounted() {
      EventBus.$on("language", data => {
        this.lan = data;
      });
    },
    computed: {
      onResize(event) {
        this.doCenter();
      },
      checkAddButton() {
        return true;
      },
      calculateAverage() {
        var managementTotal = 0;
        for (var i = 0; i < this.questions.length; i++) {
          var sum2 = 0;
          for (var j = 0; j < this.questions[i].skillLevels.length; j++) {
            for (let k = 0; k < this.questions[i]["userSkillLevel" + (j + 1)].length; k++) {
              if (this.questions[i]["userSkillLevel" + (j + 1)].length != 0) {
                 let selectedObj = {};
                  let isSelected =this.questions[i].skillLevels[j].scores.findIndex(obj => {
                  if (this.questions[i]["userSkillLevel" + (j + 1)][k].id == obj.id) {
                    selectedObj = obj;
                    return true;
                  }
                });
                  if (isSelected != -1) {
                      sum2 =
                        sum2 + selectedObj.pivot.score;
                            }
              }
            }
          }
          managementTotal = managementTotal + sum2;
        }
        this.$parent.$emit('managementTotal', managementTotal);
      }
    },
    methods: {
      clearSkillLevel(questionKey, skillLevels, chooseskill) {
        this.clearCurrentSkillLevel('' + chooseskill[chooseskill.length - 1].code + '', '' + questionKey + '');
      },
      SkillUpdateAutomatic(chooseskill, questionKey, level) {
        this.selectskilllevel(
          chooseskill[chooseskill.length - 1].id + "",
          chooseskill[chooseskill.length - 1].name + "",
          chooseskill[chooseskill.length - 1].code + "",
          chooseskill[chooseskill.length - 1].jp_name + "",
          chooseskill[chooseskill.length - 1].score,
          questionKey
        );

        this.updateSkillLevel(0, questionKey, level[0].id);
      },
      updateskill(event, questionKey) {
        var code = event.clone.id.substr(2);
        var name = event.clone.textContent;

        var index = 0;
        for (var i = 0; i < this.questions[questionKey].chooseskill.length; i++) {
          if (this.questions[questionKey].chooseskill[i].code === code) {
            var newItem = {
              name: name,
              code: code,
              clicked: true,
              dragged: true
            }
            this.questions[questionKey].chooseskill.splice(index, 1, newItem);
            break;
          }
          index++;
        }


        var newItem = {
          name: name,
          code: code,
          skilllevel: false,
          connected: false
        }
        for (var i = 0; i < this.questions[questionKey].userSkillLevel1.length; i++) {
          if (this.questions[questionKey].userSkillLevel1[i].code === code) {
            var newItem = {
              name: name,
              code: code,
              skilllevel: false,
              connected: true
            }
            break;
          }
        }

        for (var i = 0; i < this.questions[questionKey].userSkillLevel2.length; i++) {
          if (this.questions[questionKey].userSkillLevel2[i].code === code) {
            var newItem = {
              name: name,
              code: code,
              skilllevel: false,
              connected: true
            }
            break;
          }
        }

        for (var i = 0; i < this.questions[questionKey].userSkillLevel3.length; i++) {
          if (this.questions[questionKey].userSkillLevel3[i].code === code) {
            var newItem = {
              name: name,
              code: code,
              skilllevel: false,
              connected: true
            }
            break;
          }
        }

        for (var i = 0; i < this.questions[questionKey].userSkillLevels.length; i++) {
          if (this.questions[questionKey].userSkillLevels[i].code === code) {
            var newItem = {
              name: name,
              code: code,
              skilllevel: false,
              connected: true
            }
            return this.questions[questionKey].userSkillLevels.splice(i, 1, newItem);
          }
        }

        return this.questions[questionKey].userSkillLevels.push(newItem);

      },
      getManagementCollection: function () {
        this.loading = true;
        return axios.get("sub-categories?category_id=2").then(res => {
          this.result = res;
          for (var i = 0; i < res.data.subcategory.length; i++) {
            var dsi = res.data.subcategory[i];
            var skills = [];
            for (var j = 0; j < dsi.items.length; j++) {
              var itemsSkill = dsi.items[j].check_content;
              var itemsSkillId = dsi.items[j].id;
              skills.push({
                id: dsi.items[j].id,
                name: itemsSkill,
                code: itemsSkill,
                jp_name: dsi.items[j].jp_check_content
              });
            }
            var skillLavel = [];
            for (var k = 0; k < dsi.levels.length; k++) {
              var itemsSkilllevel = dsi.levels[k];
              skillLavel.push(itemsSkilllevel);
            }
            var definition = [];
            for (var l = 0; l < dsi.definitions.length; l++) {
              var itemsDefinition = dsi.definitions[l];
              definition.push(itemsDefinition);
            }
            this.mangQue.push({
              id: dsi.id,
              skillquestionEn: dsi.name,
              skillquestionJp: dsi.jp_name,
              skillquestionDescriotion: dsi.description,
              skillquestionJpDescriotion: dsi.jp_description,
              multiselect: dsi.multiselect == 1 ? true : false,
              chooseskill: dsi.multiselect == 1 ? [] : skills,
              skilldropdown: skills,
              skillLevels: skillLavel,
              definitions: definition,
              userSkillLevels: [],
              userSkillLevel1: [],
              userSkillLevel2: [],
              userSkillLevel3: [],
              userSkillLevel4: [],
              userSkillLevel5: []
            });

          }
          this.questions = this.mangQue;
          this.isManagementQuestionsLoaded = true;
          this.getUserSkillsItems();
        });
      },
      addNewSkill(newTag, index) {
        const tag = {
          name: newTag,
          code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
          clicked: false
        };
        this.questions[index].skilldropdown.push(tag);
        this.questions[index].chooseskill.push(tag);
      },
      selectskilllevel: function (id, name, code, jp_name, questionKey) {
        var index = -1;
        for (
          var i = 0;
          i < this.questions[questionKey].userSkillLevels.length;
          i++
        ) {
          if (this.questions[questionKey].userSkillLevels[i].code === code) {
            index = i;
            break;
          }
        }
        if (index !== -1) {
          for (
            var i = 0;
            i < this.questions[questionKey].userSkillLevel1.length;
            i++
          ) {
            if (this.questions[questionKey].userSkillLevel1[i].code === code) {
              this.questions[questionKey].userSkillLevel1.splice(i, 1);
              break;
            }
          }
          for (
            var i = 0;
            i < this.questions[questionKey].userSkillLevel2.length;
            i++
          ) {
            if (this.questions[questionKey].userSkillLevel2[i].code === code) {
              this.questions[questionKey].userSkillLevel2.splice(i, 1);
              break;
            }
          }
          for (
            var i = 0;
            i < this.questions[questionKey].userSkillLevel3.length;
            i++
          ) {
            if (this.questions[questionKey].userSkillLevel3[i].code === code) {
              this.questions[questionKey].userSkillLevel3.splice(i, 1);
              break;
            }
          }
          for (
            var i = 0;
            i < this.questions[questionKey].userSkillLevel4.length;
            i++
          ) {
            if (this.questions[questionKey].userSkillLevel4[i].code === code) {
              this.questions[questionKey].userSkillLevel4.splice(i, 1);
              break;
            }
          }
          for (
            var i = 0;
            i < this.questions[questionKey].userSkillLevel5.length;
            i++
          ) {
            if (this.questions[questionKey].userSkillLevel5[i].code === code) {
              this.questions[questionKey].userSkillLevel5.splice(i, 1);
              break;
            }
          }
          return this.questions[questionKey].userSkillLevels.splice(index, 1);
        } else {
          var newItem = {
            name: name,
            code: code,
            id: id,
            skilllevel: false,
            connected: false,
            jp_name: jp_name
          };
          for (
            var i = 0;
            i < this.questions[questionKey].userSkillLevel1.length;
            i++
          ) {
            if (this.questions[questionKey].userSkillLevel1[i].code === code) {
              var newItem = {
                name: name,
                code: code,
                id: id,
                skilllevel: false,
                connected: true,
                jp_name: jp_name
              };
              break;
            }
          }

          for (
            var i = 0;
            i < this.questions[questionKey].userSkillLevel2.length;
            i++
          ) {
            if (this.questions[questionKey].userSkillLevel2[i].code === code) {
              var newItem = {
                name: name,
                code: code,
                id: id,
                skilllevel: false,
                connected: true,
                jp_name: jp_name
              };
              break;
            }
          }

          for (
            var i = 0;
            i < this.questions[questionKey].userSkillLevel3.length;
            i++
          ) {
            if (this.questions[questionKey].userSkillLevel3[i].code === code) {
              var newItem = {
                name: name,
                code: code,
                id: id,
                skilllevel: false,
                connected: true,
                jp_name: jp_name
              };
              break;
            }
          }
          for (
            var i = 0;
            i < this.questions[questionKey].userSkillLevel4.length;
            i++
          ) {
            if (this.questions[questionKey].userSkillLevel4[i].code === code) {
              var newItem = {
                name: name,
                code: code,
                id: id,
                skilllevel: false,
                connected: true,
                jp_name: jp_name
              };
              break;
            }
          }
          for (
            var i = 0;
            i < this.questions[questionKey].userSkillLevel5.length;
            i++
          ) {
            if (this.questions[questionKey].userSkillLevel5[i].code === code) {
              var newItem = {
                name: name,
                code: code,
                id: id,
                skilllevel: false,
                connected: true,
                jp_name: jp_name
              };
              break;
            }
          }
          return this.questions[questionKey].userSkillLevels.push(newItem);
        }
      },
      updateSkillLevel: function (skilllevel, questionKey, id) {
        var index = 0;
        for (
          var i = 0;
          i < this.questions[questionKey].userSkillLevels.length;
          i++
        ) {
          if (
            this.questions[questionKey].userSkillLevels[i].connected === false
          ) {
            var newItem = {
              name: this.questions[questionKey].userSkillLevels[i].name,
              code: this.questions[questionKey].userSkillLevels[i].code,
              id: this.questions[questionKey].userSkillLevels[i].id,
              skilllevel: skilllevel,
              connected: true,
              jp_name:
                this.questions[questionKey].userSkillLevels[i].jp_name + " "
            };

            if (skilllevel === 0) {
              this.questions[questionKey].userSkillLevel1.push(newItem);
              this.questions[questionKey].userSkillLevel1.sort(function(a, b) {
              return a.id - b.id;
              });
              this.itemId.push(newItem.id);
              this.skillLevelId.push(id);
            } else if (skilllevel === 1) {
              this.questions[questionKey].userSkillLevel2.push(newItem);
              this.questions[questionKey].userSkillLevel2.sort(function(a, b) {
              return a.id - b.id;
              });
              this.itemId.push(newItem.id);
              this.skillLevelId.push(id);
            } else if (skilllevel === 2) {
              this.questions[questionKey].userSkillLevel3.push(newItem);
              this.questions[questionKey].userSkillLevel3.push(newItem);
              this.questions[questionKey].userSkillLevel3.sort(function(a, b) {
                return a.id - b.id;
              });
              this.itemId.push(newItem.id);
              this.skillLevelId.push(id);
            } else if (skilllevel === 3) {
              this.questions[questionKey].userSkillLevel4.push(newItem);
              this.questions[questionKey].userSkillLevel4.sort(function(a, b) {
              return a.id - b.id;
              });
              this.itemId.push(newItem.id);
              this.skillLevelId.push(id);
            } else if (skilllevel === 4) {
              this.questions[questionKey].userSkillLevel5.push(newItem);
              this.questions[questionKey].userSkillLevel5.sort(function(a, b) {
              return a.id - b.id;
              });
              this.itemId.push(newItem.id);
              this.skillLevelId.push(id);
            }

            let vm = this;
            this.questions[questionKey].userSkillLevels.splice(index, 1, newItem);
            let labelToHide =
              "li" + vm.questions[questionKey].userSkillLevels[i].code;
            setTimeout(() => {
              if (document.getElementById(labelToHide)) {
                document.getElementById(labelToHide).style =  "display: none !important;";
              }
            }, 100);
          } else {
          }
          index++;
        }
         this.updateId();
      },
      clearCurrentSkillLevel: function (code, questionKey) {
        for (
          var i = 0;
          i < this.questions[questionKey].userSkillLevels.length;
          i++
        ) {
          if (this.questions[questionKey].userSkillLevels[i].code === code) {
            this.questions[questionKey].userSkillLevels.splice(i, 1);
            break;
          }
        }

        for (var i = 0; i < this.questions[questionKey].chooseskill.length; i++) {
          if (this.questions[questionKey].chooseskill[i].code === code) {
            var data = {
              name: this.questions[questionKey].chooseskill[i].name,
              jp_name: this.questions[questionKey].chooseskill[i].jp_name,
              code: code,
              id: this.questions[questionKey].chooseskill[i].id,
              clicked: false
            };
            if (this.questions[questionKey].chooseskill[i].code)
              document.getElementById(
                "li" + this.questions[questionKey].chooseskill[i].code
              ).style =
                "display: inline-block;";
            this.questions[questionKey].chooseskill.splice(i, 1, data);
          }
        }

        for (
          var i = 0;
          i < this.questions[questionKey].userSkillLevel1.length;
          i++
        ) {
          if (this.questions[questionKey].userSkillLevel1[i].code === code) {
            let index = this.itemId.findIndex(obj => {
              if ((obj + '') == this.questions[questionKey].userSkillLevel1[i].id) {
                return true;
              }
            })
            if (index != -1) {
              this.itemId.splice(index, 1);
              this.skillLevelId.splice(index, 1);
            }
            this.questions[questionKey].userSkillLevel1.splice(i, 1);
            break;
          }
        }
        for (
          var i = 0;
          i < this.questions[questionKey].userSkillLevel2.length;
          i++
        ) {
          if (this.questions[questionKey].userSkillLevel2[i].code === code) {
            let index = this.itemId.findIndex(obj => {
              if ((obj + '') == this.questions[questionKey].userSkillLevel2[i].id) {
                return true;
              }
            })
            if (index != -1) {
              this.itemId.splice(index, 1);
              this.skillLevelId.splice(index, 1);
            }
            this.questions[questionKey].userSkillLevel2.splice(i, 1);
            break;
          }
        }
        for (
          var i = 0;
          i < this.questions[questionKey].userSkillLevel3.length;
          i++
        ) {
          if (this.questions[questionKey].userSkillLevel3[i].code === code) {
            let index = this.itemId.findIndex(obj => {
              if ((obj + '') == this.questions[questionKey].userSkillLevel3[i].id) {
                return true;
              }
            })
            if (index != -1) {
              this.itemId.splice(index, 1);
              this.skillLevelId.splice(index, 1);
            }
            this.questions[questionKey].userSkillLevel3.splice(i, 1);
            break;
          }
        }
        for (
          var i = 0;
          i < this.questions[questionKey].userSkillLevel4.length;
          i++
        ) {
          if (this.questions[questionKey].userSkillLevel4[i].code === code) {
            let index = this.itemId.findIndex(obj => {
              if ((obj + '') == this.questions[questionKey].userSkillLevel4[i].id) {
                return true;
              }
            })
            if (index != -1) {
              this.itemId.splice(index, 1);
              this.skillLevelId.splice(index, 1);
            }
            this.questions[questionKey].userSkillLevel4.splice(i, 1);
            break;
          }
        }
        for (
          var i = 0;
          i < this.questions[questionKey].userSkillLevel5.length;
          i++
        ) {
          if (this.questions[questionKey].userSkillLevel5[i].code === code) {
            let index = this.itemId.findIndex(obj => {
              if ((obj + '') == this.questions[questionKey].userSkillLevel5[i].id) {
                return true;
              }
            })
            if (index != -1) {
              this.itemId.splice(index, 1);
              this.skillLevelId.splice(index, 1);
            }
            this.questions[questionKey].userSkillLevel5.splice(i, 1);
            break;
          }
        }
        this.updateId();
      },
      getUserSkillsItems() {
       
        axios
          .get("user-skills?token=" + localStorage.getItem("token"))
          .then(response => {
              setTimeout(() => {
                  this.loaded = true;
              }, 100);
            this.userSkillResponse = response;
            this.model.total = response.data.total;
            this.model.technical = response.data.technical_total;
            this.model.management = response.data.other_total;
            setTimeout(() => {
               this.loading = false;
            }, 500);
            for (let i = 0; i < this.mangQue.length; i++) {

              for (let j = 0; j < this.mangQue[i].skilldropdown.length; j++) {
                let selectedSkill = {};
                let isSelected = response.data.skills.findIndex(obj => {
                  if (this.mangQue[i].skilldropdown[j].id == obj.item_id) {
                    selectedSkill = obj;
                    return true;
                  }
                });
                if (isSelected != -1) {
                  if (this.mangQue[i].multiselect == true) {
                    this.questions[i].chooseskill.push(this.mangQue[i].skilldropdown[j]);

                    this.mangQue[i].chooseskill[this.mangQue[i].chooseskill.length - 1].clicked = true;
                    let chooseskill = this.mangQue[i].chooseskill[this.mangQue[i].chooseskill.length - 1];
                    this.selectskilllevel(chooseskill.id + "", chooseskill.name, chooseskill.code, chooseskill.jp_name, i);

                    let selectedLevel = this.mangQue[i].skillLevels.findIndex(obj => {
                      if (obj.id == selectedSkill.level_id) {
                        return true;
                      }
                    });
                    this.updateSkillLevel(selectedLevel, i, this.mangQue[i].skillLevels[selectedLevel].id);
                  } else {
                    let index = this.mangQue[i].chooseskill.findIndex(obj => obj.id == this.mangQue[i].skilldropdown[j].id);
                    this.mangQue[i].chooseskill[index].clicked = true;
                    let chooseskill = this.mangQue[i].chooseskill[index];
                    this.selectskilllevel(chooseskill.id + "", chooseskill.name, chooseskill.code, chooseskill.jp_name, i);

                    let selectedLevel = this.mangQue[i].skillLevels.findIndex(obj => {
                      if (obj.id == selectedSkill.level_id) {
                        return true;
                      }
                    });
                    this.updateSkillLevel(selectedLevel, i, this.mangQue[i].skillLevels[selectedLevel].id);
                  }
                }
              }
            }
            for (let i = 0; i < response.data.answers.Management.length; i++) {
              this.customManagementSkill[response.data.answers.Management[i].subcategory.id] = response.data.answers.Management[i].answer

            }
          })
          .catch(error => {
          });
      },
      updateId() {
        this.$parent.$emit('managementId', {
          itemId: this.itemId,
          level_id: this.skillLevelId,
          custom_skill: this.customManagementSkill,
          loaded: this.loaded
        });
      }
    }
  };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
  .dragged {
  display: none;
}

.skillUpdate {
  padding-top: 10px;
  float: left;
  width: 100%;
}

.layer {
  width: 100%;
  border: 1px solid #3d7dd8;
  font-weight: 500;
  letter-spacing: 1.4px;
  color: #3d7dd8;
  padding: 8px 8px 0;
  margin-right: 5px;
  text-align: justify;
  /* white-space: pre;
          word-break: keep-all; */
  display: inline-block;
  border-radius: 5px;
}

.layer > div {
  float: left;
  width: 100%;
  min-height: 100px;
}

.layer ul {
  list-style: circle;
}

.layer ul li {
  display: list-item;
  padding-left: 0;
  padding-right: 15px;
  width: 100%;
}

.layer ul li span {
  /* color: #404040;
          background: #d0cbcb; */
  color: #fff;
  background: #3d7dd8;
  padding: 4px 10px;
  font-size: 30px;
  text-decoration: none;
  border-radius: 3px;
  margin: 2px;
  float: left;
}

.skillTag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #3d7dd8 !important;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  min-height: 22px !important;
}

.resultshow ul li {
  -webkit-animation: animationtags 1s ease-out; /* Safari 4.0 - 8.0 */
  animation: animationtags 1s ease-out;
  animation-iteration-count: 1;
}

/* Standard syntax */
@keyframes animationtags {
  0% {
    width: 100%;
    transform: rotate(-6deg);
  }
  100% {
    width: 100%;
    transform: rotate(0deg);
  }
}

.chooseskillssection input[type="checkbox"] {
  -webkit-appearance: none;
}

.level_btns input[type="radio"] {
  display: none;
}

/* Standard syntax */
@keyframes animationtags {
  0% {
    width: 100%;
    transform: rotate(-6deg);
  }
  100% {
    width: 100%;
    transform: rotate(0deg);
  }
}

.chooseskillssection input[type="checkbox"] {
  -webkit-appearance: none;
}

.level_btns input[type="radio"] {
  display: none;
}

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  font-family: "Lato", sans-serif;
}

.facheck:before {
  content: "\f00c";
}


header .logo {
  text-align: center;
}


.chooseskillssection ul {
  list-style: none;
}

.chooseskillssection li {
  float: left;
}

.chooseskillssection li label {
  color: #404040;
  background: #d0cbcb;
  padding: 4px 10px;
  font-size: 16px;
  text-decoration: none;
  border-radius: 3px;
  margin: 2px;
  cursor: pointer;
}

.chooseskillssection li label.clicked {
  /* background: rgba(50, 209, 108, 0.65); */
  color: #fff;
  background: #3d7dd8;
}

.multiselect__tags-wrap .multiselect__tag {
  background: #3d7dd8 !important;
}
/* #liTerraform{
    display: none;
  } */
.selectexpertlevel {
  float: left;
  width: 100%;
  grid-auto-columns: auto;
  display: grid;
}

.selectexpertlevel > div.level_btns {
  grid-area: 1;
  font-size: 1rem;
  text-align: center;
}

.selectexpertlevel > div label {
  padding: 20px;
  display: block;
  background: #fff;
  box-shadow: 2px 2px 2px 2px #ccc;
  margin: 10px;
  min-height: 65px;
  cursor: pointer;
}

.selectexpertlevel > div label:hover {
  background: #efeeee;
}

.selectexpertlevel > div label span {
  width: 60%;
  float: left;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #d2cfcf;
  margin-left: 20%;
  margin-right: 20%;
}

.resultshow {
  float: left;
  background: #fff;
  min-height: 50px;
  width: 100%;
}

.resultshow > div {
  float: left;
  text-align: left;
  margin-bottom: 15px;
  width: 100%;
  min-height: 50px;
}

.resultshow ul {
  padding-left: 5px;
  margin-top: 0px;
  margin-bottom: 0px;
  list-style: none;
  text-align: left;
  display: inline-block;
}

.resultshow ul li {
  display: list-item;
  padding-left: 0;
  float: left;
  width: 100%;
}

.resultshow ul li span {
  /* color: #404040;
          background: #d0cbcb; */
  color: #fff;
  background: #3d7dd8;
  padding: 4px 10px;
  font-size: 16px;
  text-decoration: none;
  border-radius: 3px;
  margin: 2px;
  float: left;
}

.filterSpinner {
  color: #3d7dd8;
}

button.save_btn {
  background: #088e38;
  color: #fff;
  border: none;
  padding: 10px 40px;
  font-size: 20px;
  margin-bottom: 20px;
  margin-top: 10px;
  float: left;
  cursor: pointer;
}

button.save_btn:hover {
  opacity: 0.9;
}

.finalResult {
  float: left;
  width: 100%;
}

.finalResult ul li {
  margin-bottom: 0px;
  width: 100%;
  display: inline-block;
  border-bottom: 1px solid #ccc;
}

.finalResult ul li p {
  margin-left: 10px;
}

.finalResult ul li h5 {
  margin-bottom: 7px;
  float: left;
  width: 100%;
}

.skill_questions {
  display: block;
  float: left;
  width: 100%;
  padding-bottom: 20px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
}

.d-center {
  display: flex;
  align-items: center;
}

.selected img {
  width: auto;
  max-height: 23px;
  margin-right: 0.5rem;
}

.v-select .dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
  border-bottom: none;
}

.v-select .dropdown li a {
  padding: 10px 20px;
  width: 100%;
  font-size: 1.25em;
  color: #3c3c3c;
}

.v-select .dropdown-menu .active > a {
  color: #fff;
}

.mainbody:after {
  position: absolute;
  content: url("../../assets/imgs/zoomtool.png");
  top: -1px;
  right: 60px;
  margin-top: 25px;
}

.regselectboxs {
  float: left;
  margin-left: 5px;
}

.reglabels {
  font-size: 0.875rem;
  font-weight: 600;
  padding: 20px 0;
}

.regradioboxs {
  text-align: center;
  min-width: 145px;
  height: 50px;
  float: left;
  background-color: #ffffff;
  border: 1px solid #b4bec8;
  color: #b4bec8;
  margin-left: 16px;
  margin-top: 5px;
  padding-top: 10px;
  border-radius: 4px;
  cursor: pointer;
}

.manradio:hover,
.mchosen {
  border: 1px solid #3d7dd8;
  color: #3d7dd8;
}

.womenradio:hover,
.wchosen {
  border: 1px solid #f878c8;
  color: #f878c8;
}

.regradiotxt {
  font-size: 0.875rem;
  font-weight: bold;
}

.regnext_btn {
  width: 100%;
  height: 56px;
  margin-top: 50px;
  font-weight: bold;
  font-size: 1rem;
}

.skipbtn {
  margin-top: 25px;
  font-weight: bold;
  font-size: 1rem;
  text-align: center;
}

.selectdiv select {
  height: 50px !important;
}

.sexerror {
  margin-top: 60px;
  margin-bottom: 20px;
  margin-left: 16px;
}

@media screen and (max-width: 1200px) {
  .mainbody:after {
    right: 20px;
  }
  
  .regselectboxs {
    float: left;
    margin-left: 5px;
  }

  .regradioboxs {
    margin-left: 5px;
  }

  .sexerror {
    margin-left: 5px;
  }
}

.statuspanel {
  background-color: #f8f8fa;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  margin-bottom: 0.1rem;
}

.radiolabel {
  font-size: 0.875rem;
  font-weight: 500;
}

input[type="radio"] {
  margin: 0 20px;
  width: 16px;
  height: 16px;
  background: #f0f2f4;
  box-shadow: inset 0 0 0 0em white, 0 0 0 0.05em;
  border-radius: 50%;
  transition: 0.2s;
  cursor: pointer;
  color: #dcdee0;
}

input[type="radio"]:hover,
input[type="radio"]:checked {
  background: #3d7dd8;
  box-shadow: inset 0 0 0 0.6em white, 0 0 0 0.3em;
}

input[type="radio"]:checked {
  background: #3d7dd8;
  box-shadow: inset 0 0 0 0.15em white, 0 0 0 0.1em #3d7dd8;
}

input[type="radio"]:focus {
  outline: 0;
}

.paddings {
  padding: 0px 150px;
}

.qtitle {
  font-size: 0.875rem;
  margin-left: 19px;
  font-weight: 500;
}

.qaboxes {
  margin-top: 30px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  max-width: 200px;
  height: 100px;
}

.statusnum {
  position: absolute;
  right: 46%;
  top: 55%;
  font-weight: bold;
  font-size: 1.5rem;
}

.two-digit statusnum {
  right: 45%;
}

.three-digit {
  right: 43%;
}

.totalcol::after {
  content: "";
  border-left: 2px solid #e4e4e6;
  position: absolute;
  height: 84%;
  right: 0;
  top: 8%;
}


@media screen and (max-width: 992px) {
   .selectskill li{
    float: none;
    margin-top: -25px;
  }
  .chooseskillssection input[type="checkbox"] {
    -webkit-appearance: none;
    opacity: 0;
    border-radius: 0;
  }
  .selectexpertlevel {
      margin-left: 18px;
      width: 100%;
      display: inline-block;
    }
    .mainbody:after {
      right: -20px;
    }

    .regselectboxs {
      float: left;
      width: 100%;
    }

    regradioboxs {
      margin-left: 16px;
    }
  }
@media screen and (max-width: 768px) {
   .selectskill li{
    float: none;
    margin-top: -25px;
  }
  .chooseskillssection input[type="checkbox"] {
    -webkit-appearance: none;
    opacity: 0;
    border-radius: 0;
  }
  .selectexpertlevel {
    margin-left: 18px;
    width: 100%;
    display: inline-block;
  }
  .resultshow ul li span {
    color: #fff;
    background: #3d7dd8;
    padding: 4px 10px;
    font-size: 16px;
    text-decoration: none;
    border-radius: 3px;
    margin: 2px;
    width: 100%;
    float: left;
}
.layer li {
  margin-top:  0px;
}
  .chooseskillssection {
    margin-left: -40px;
}
 
  .chooseskillssection ul{
    margin-left: 0px;
  }
  .chooseskillssection li label{
    width: 100%;
  }
  .mainbody:after {
    right: -60px;
  }
  .paddings {
    padding: 0px 0px;
  }
  .totalcol::after {
    content: "";
    border-left: 2px solid transparent;
    position: absolute;
    height: 84%;
    right: 0;
    top: 8%;
  }
  .pman {
    margin-top: 0px;
  }

  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }
}

@media screen and (max-width: 678px) {
  .chooseskillssection input[type="checkbox"] {
    -webkit-appearance: none;
    opacity: 0;
    border-radius: 0;
  }
  .mainbody:after {
    right: 0px;
    margin-top: -60px;
  }

  .mainbody {
    margin-top: 40px;
  }
}

@media screen and (max-width: 369px) {
  .regradioboxs {
    margin-top: 10px;
    width: 100%;
    margin-left: 0px;
  }
}

.pman {
  width: 120px;
  margin-top: 70px;
}

.slide_options {
  background-color: #f8fafa;
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
  width: 80%;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 21px;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  max-width: 200px;
  height: 100px;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  margin-bottom: 0.1rem;
}

.statusnum {
  position: absolute;
  /*right: 46%;
            top: 55%;*/
  font-weight: bold;
  font-size: 1.5rem;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}
</style>